<template>
  <div class="tracker-multiselect">
    <b-form-group
      :label="label"
      :label-cols="spacing"
      :horizontal="true">
      <multiselect :value="value" v-model="selected" @input="updateInput()" :options="trackerNames"
        track-by="name" label="name" :multiple="multiple" selectLabel="" deselectLabel="Remove"
        placeholder="Select Tracker" :disabled="disabled" :class="{invalid: invalid}"></multiselect>
    </b-form-group>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'TrackerDropdown',
  data() {
    return {
      selected: null,
      initializedTrackerNames: false,
      initializedGcu: false
    };
  },
  computed: {
    trackerNames() {
      let trackerOutput = null;
      if (this.gcu) {
        trackerOutput = this.$store.getters['savanna/trackers/getTrackerNames'](this.gcu);
      } else {
        trackerOutput = [];
      }

      trackerOutput = trackerOutput.map((element) => {
        element.gcu = this.gcu;
        return element;
      });

      return trackerOutput;
    }
  },
  props: {
    value: [Object, Array],
    label: {
      type: String,
      default: 'Tracker'
    },
    spacing: {
      type: Number,
      default: 3
    },
    gcu: {
      type: String,
      default: null
    },
    gcuRequired: {
      type: Boolean
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cacheKey: {
      type: String,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateInput() {
      this.$emit('input', this.selected);

      if (this.cacheKey) {
        if (this.selected) {
          this.$store.dispatch('localstorage/saveToLocalStorage', { key: 'tracker_' + this.cacheKey, value: this.selected });
        } else {
          this.$store.dispatch('localstorage/removeFromLocalStorage', { key: 'tracker_' + this.cacheKey });
        }
      }
    }
  },
  watch: {
    gcu() {
      this.selected = null;
      if (this.initializedGcu && this.cacheKey) {
        this.$store.dispatch('localstorage/removeFromLocalStorage', { key: 'tracker_' + this.cacheKey });
      }
      
      this.initializedGcu = true;
    },
    value() {
      this.selected = this.value;
    },
    trackerNames(names) {
      if (names.length === 0) return;

      if (!this.initializedTrackerNames && this.cacheKey) {
          this.initializedTrackerNames = true;
          this.$store.dispatch('localstorage/getFromLocalStorage', { key: 'tracker_' + this.cacheKey })
            .then((data) => {
              if (data) {
                if (!this.multiple) {
                  const found = names.find((val) => {
                    return this.gcu === data.gcu && val.id === data.id && val.name === data.name;
                  });

                  if (found) {
                    this.selected = data;
                    this.$emit('input', this.selected);
                  }
                }

                else {
                  let foundAll = true;
                  data.forEach((element, index) => {
                    const found = names.find((val) => {
                      return this.gcu === element.gcu && val.id === element.id && val.name === element.name;
                    });

                    if (!found) {
                      foundAll = false;
                    }
                  });

                  if (foundAll) {
                    this.selected = data;
                    this.$emit('input', this.selected);
                  }
                }
              }
            });
          }
      }
  },
  components: {
    Multiselect
  }
};
</script>

<style scoped>
  .form-group {
    margin-bottom: 0.5rem;
  }
</style>
<style>
  .tracker-multiselect .multiselect .multiselect__option--highlight {
    background: #FF9E1B
  }

  .tracker-multiselect .multiselect .multiselect__option--selected.multiselect__option--highlight {
    background: #FF6A6A
  }

  .tracker-multiselect .multiselect.invalid .multiselect__tags {
    border-color: #F86C6B
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
